<template>
  <div class="masonry-app">
    <div style="position:relative">
      <h1>{{langCode == 'se' ? 'Inspiration' : 'Inspiration'}}</h1>

      <div class="masonry-app--filter-container">
        <button
          class="btn"
          :class="{'active': filter == 'all' }"
          @click.stop.prevent="filter = 'all'"
        >{{t("all")}}</button>
        <button
          class="btn"
          :class="{'active': filter == 'IncludesTables' }"
          @click.stop.prevent="resetLoadedItems(); filter = 'IncludesTables'"
        >{{t("tables")}}</button>
        <button
          class="btn"
          :class="{'active': filter == 'IncludesExposureSystem' }"
          @click.stop.prevent="resetLoadedItems(); filter = 'IncludesExposureSystem'"
        >{{t("displaySystems")}}</button>
        <button
          class="btn"
          :class="{'active': filter == 'IncludesStorage' }"
          @click.stop.prevent="resetLoadedItems(); filter = 'IncludesStorage'"
        >{{t("storages")}}</button>
        <button
          class="btn"
          :class="{'active': filter == 'IncludesClothesHanger' }"
          @click.stop.prevent="resetLoadedItems(); filter = 'IncludesClothesHanger'"
        >{{t("coatRacks")}}</button>
        <button
          class="btn"
          :class="{'active': filter == 'IncludesSeating' }"
          @click.stop.prevent="resetLoadedItems(); filter = 'IncludesSeating'"
        >{{t("seatings")}}</button>
      </div>
    </div>

    <div
      class="masonry-app--item-container"
      v-masonry
      gutter="20"
      isFitWidth="true"
      transition-duration="0"
      item-selector=".masonry-app--item"
      horizontal-order="true"
      stagger="0"
    >
      <div v-if="isLoading">
        <div
          class="masonry-app--item"
          v-masonry-tile
          :style="`height:${x*80}px`"
          v-for="(x, index) in [2,3,2,4,5,6,2,3,4]"
          :key="index"
        ></div>
      </div>
      <div class="is-loaded" v-else>
        <div
          class="masonry-app--item"
          v-masonry-tile
          v-for="(x, index) in displayedItems"
          :key="x.ArticleId"
        >
          <div :style="`width: 100%;padding-bottom: ${x.AspectRatio * 100}%;`">
            <img
              v-if="index < loadedItems && !x.error"
              :src="`/$1/Article/${x.ArticleId}/1/400x-1/${x.Filename}`"
              @click="showImage(index)"
              :alt="x.ImageAltText"
              @error="x.error = true"
            />
            <div v-else-if="x.error"  @click="showImage(index)" style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)">
              <span :title="langCode == 'se' ? 'Kunde inte ladda bilden' : 'Failed to load the image'" style="color: #efecec;font-size: 10rem" class="fa-stack fa-2x">
<span class="fa fa-image fa-stack-1x"></span>

              </span>
            </div>
            <mugen-scroll v-if="index == loadedItems - 1" 
              :threshold="1" 
              :handler="() => { loadedItems = loadedItems + 4; preloadItems();  }"
            />
          </div>
        </div>
      </div>
    </div>

    <ImageModal 
      :image="selectedImage"
      :nextImage="nextImage"
      :prevImage="prevImage"
      :langCode="langCode"
        @close="imageIndex = null"
        @next="imageIndex++"
        @prev="imageIndex--"
      />
  </div>
</template>

<script>
import axios from "axios";
import ImageModal from "@/components/ImageModal";

export default {
  name: "app",
  components: { ImageModal },
  data() {
    return {
      items: [],
      loadedItems: 6,
      isLoading: true,
      filter: "all",
      imageIndex: null,
      isLoadingImage: false,
      isLoadingNextImage: false,
      langCode: (document.getElementById("masonry-lang-code").value || "se").toLowerCase(),
      translations: {
        se: {
          all: "Allt",
          tables: "Bord",
          displaySystems: "Exponeringssystem",
          storages: "Förvaring",
          seatings: "Sittmöbler",
          coatRacks: "Klädhängare"
        },
        uk: {
          all: "All",
          tables: "Tables",
          displaySystems: "Display systems",
          storages: "Storages",
          seatings: "Seatings",
          coatRacks: "Coat racks"
        }
      }
    };
  },
  computed: {
    filteredItems() {
      if (this.filter == "all") return this.items;

      return this.items.filter(x => x[this.filter]);
    },
    displayedItems() {
      return this.filteredItems.slice(0, this.loadedItems + 5);
    },
    selectedImage() {
      if(this.imageIndex == null)
        return null;

      return this.filteredItems[this.imageIndex];
    },
    nextImage() {
      if(this.imageIndex + 1 >= this.filteredItems.length)
        return null;

      return this.filteredItems[this.imageIndex+1];
    },
    prevImage() {
      if((this.imageIndex - 1) <= -1)
        return null;

      return this.filteredItems[this.imageIndex-1];
    }
  },
  mounted() {
    const folderId = document.getElementById("masonry-folder-id").value;

    axios
      .get(`/inc/masonry_api.ashx?fid=${folderId}&lc=${this.langCode}`)
      .then(response => {
        this.items = response.data.map(x => ({...x, error: false}));
        this.isLoading = false;
      })
      .catch(error => console.log(error));
  },
  methods: {
    showImage(index) {
      this.imageIndex = index;
      this.isLoadingImage = false;
    },
    resetLoadedItems() {
      this.loadedItems = 6;
    },
    preloadItems() {
      const result = this.items.slice(this.loadedItems - 1, 3).map(x => {
        const img = new Image();
        img.src = `/$1/Article/${x.ArticleId}/1/400x-1/${x.Filename}`;
      });
    },
    t(item) {
      return this.translations[this.langCode][item] || "[No translation]"
    }
  }
};
</script>

<style lang="scss" scoped>
.masonry-app {
  margin-right: -20px;
}


.masonry-app--filter-container {
  position: absolute;
  top: 0;
  right: 0;

  @media screen and (max-width: 1000px) {
    position: static;
    padding-right: 20px;
    margin: 0 -0.5rem;
  }

  .btn {
    @media screen and (max-width: 1000px) and (min-width: 501px) {
      width: calc(33.3333333% - 1rem);
      margin: 0 0.5rem;
      margin-bottom: 1rem;
    }

    @media screen and (max-width: 500px) {
      width: calc(50% - 1rem);
      margin: 0 0.5rem;
      margin-bottom: 1rem;
    }

    @media screen and (min-width: 1001px) {
      margin: 0 0.5rem;

      &:first-of-type {
        margin-left: 0;
      }

      &:last-of-type {
        margin-right: 20px;
      }
    }

    &:hover {
      background-color: #000;
      color: #fff;
    }

    &.active {
      background-color: #000;
      color: #fff;
    }
  }
}

.masonry-app--item-container {
  position: relative;
}

.masonry-app--item {
  background: #f5f5f5;
  border-radius: 5px;
  padding: 20px 0;
  width: calc(25% - 20px);

  @media screen and (max-width: 768px) {
    width: calc(33.33333333333333% - 20px);
  }

  @media screen and (max-width: 500px) {
    width: calc(50% - 20px);
  }

  margin-bottom: 20px;

  img {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.85;
    }
  }
}

.is-loaded .masonry-app--item {
  padding: 0;
}
</style>
